module.exports = __webpack_public_path__ + "static/img/seb1.3e6d6fc5.png";